<template>
    <loading-spinner v-if="fetchingNfts"
        class="spinner"
    />

    <div v-else
        class="carousel-container"
    >
        <carousel v-if="hasNfts"
            :navigationEnabled="true"
            navigation-next-label=""
            navigation-prev-label=""
            :paginationEnabled="false"
            :scrollPerPage="false"
            :perPageCustom="[
                [400, 2],
                [900, 3],
            ]"
        >
            <slide v-for="(nft, index) of getFormattedNftsList"
                :key="index"
            >
                <nft-card-tile
                    :id="`nft-card-${index}`"
                    :key="index"
                    :nft="nft"
                    class="nfts__tile"
                />
            </slide>
        </carousel>
        <list-empty v-else />
    </div>
</template>
<script>
// 3rd party libs
import {
    mapActions,
    mapGetters,
} from 'vuex';

// Components
import loadingSpinner from '@webapp/components/loading-spinner/loading-spinner.vue';
import listEmpty from '@webapp/components/nft/list-empty.vue';
import {
    Carousel,
    Slide,
} from 'vue-carousel';
import nftCardTile from '@webapp/components/nft/card.vue';

export default {
    name: 'partner-wallet-nfts',
    components: {
        loadingSpinner,
        Carousel,
        Slide,
        nftCardTile,
        listEmpty,
    },
    props: {
        partnerId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            fetchingNfts: true,
        };
    },
    computed: {
        ...mapGetters('nfts', ['getFormattedNftsList']),

        hasNfts() {
            return Boolean(this.getFormattedNftsList.length > 0);
        },
    },
    mounted() {
        this.fetchNFTs({
            limit: 1000,
            partnerIds: [this.partnerId],
        }).then(() => {
            this.fetchingNfts = false;
        });
    },
    methods: {
        ...mapActions('nfts', ['fetchNFTs']),
    },
};

</script>
<style lang="scss" scoped>
.nfts {
    &__tile {
        text-decoration: none;
        color: inherit;
        display: block;
        margin: 2rem;

        @include max-width(sm) {
            margin: 1rem;
        }
    }
}
</style>